import type { TimeDifferenceInMillisecondsExpression } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';
import { differenceInMilliseconds } from 'date-fns';

export const timeDiffInMsResolver =
  createSimpleNamedExpressionResolver<TimeDifferenceInMillisecondsExpression>(
    'timeDiffInMs',
    differenceInMilliseconds
  );
